<template>
    <section class="user-module">
        <!-- Loading -->
        <loading />

        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <!-- Module Actions -->
        <module-action
            :csrftolken="csrftolken"
            :alldata="moduleDataAction"
            @dynamic-data="getDynamicDataFromModuleAction($event)"
            :orderurl="moduleorder"
            :searchurl="modulesearch"
            classname="user-module-action"
            idname="user_header"
            :modulename="modulename"
            searchplaceholder="search by id, type, email or name"
            :createlink="modulecreate"
            subheaderstring="Cria e gere os teus utilizadores"
            mobileindicatename="userscreate"
            @user-data="getUserData($event)"
            :btnheaderactions="buttonsActionsHeader"
            :conditionalaction="wichUser"
        >
            <template #custom_action> </template>
        </module-action>

        <!-- Content -->
        <template v-if="Object.values(allData).length > 0">
            <div class="table-scroll-wrapper desktop-only">
                <!-- Page List Render-->
                <table-element
                    :classname="['table-striped', 'user-content-table']"
                >
                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">
                                <div class="id-header">
                                    <p
                                        class="color-text-body strong-400"
                                        style="border: none"
                                    >
                                        ID
                                    </p>
                                </div>
                            </th>
                            <th scope="col">
                                <p class="strong-600 color-text-body">Nome</p>
                            </th>

                            <th v-if="wichUser === 'professional'">
                                <p class="strong-600 color-text-body">Status</p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    {{
                                        wichUser === "professional"
                                            ? "Profissão"
                                            : "Posição"
                                    }}
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">Email</p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Telemóvel
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Criado em:
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Última edição
                                </p>
                            </th>

                            <th scope="col">
                                <div class="action-header">
                                    <p class="color-text-body strong-400">
                                        Ações
                                    </p>
                                </div>
                            </th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>
                        <tr
                            v-for="(value, index) in usersData"
                            :key="value.user_id"
                            :data-referindex="index"
                            :data-userid="value.user_id"
                        >
                            <th scope="row">
                                <div class="same-height id-body">
                                    <p class="strong-400">
                                        {{ value.user_id }}
                                    </p>
                                </div>
                            </th>

                            <td>
                                <p class="strong-600">
                                    {{ value.user_name }}
                                </p>
                                <p class="caption-log color-text-body">
                                    {{ value.rule_name }}
                                </p>
                            </td>

                            <td
                                v-if="
                                    value.user_rule ===
                                    parseInt(professionalrule)
                                "
                            >
                                <div class="same-height">
                                    <div
                                        :class="`${value.active.toLowerCase()}-status`"
                                    >
                                        <span class="status-circle"></span>
                                        <p>{{ value.active }}</p>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p
                                        :style="
                                            !value.position
                                                ? {
                                                      textAlign: 'center',
                                                      width: '100%',
                                                  }
                                                : null
                                        "
                                    >
                                        {{
                                            value.user_rule ===
                                            parseInt(professionalrule)
                                                ? value.profession || "-"
                                                : value.rule_name || "-"
                                        }}
                                    </p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.email }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p
                                        :style="
                                            !value.contact
                                                ? {
                                                      textAlign: 'center',
                                                      width: '100%',
                                                  }
                                                : null
                                        "
                                    >
                                        {{
                                            value.user_rule ===
                                            parseInt(professionalrule)
                                                ? value.contact.contact || "-"
                                                : value.contact || "-"
                                        }}
                                    </p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.created_at }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.updated_at }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="buttons-wrapper same-height">
                                    <div
                                        role="button"
                                        class="btn-edit"
                                        :data-referindex="index"
                                        :data-userid="value.user_id"
                                        :data-userrule="value.user_rule"
                                        data-action="edit"
                                        data-mobileindicate="usersshow"
                                        @click="buttonActions($event)"
                                    >
                                        <span
                                            data-mobileindicate="usersshow"
                                            class="content-icon"
                                            >Editar</span
                                        >
                                    </div>
                                    <div
                                        role="button"
                                        class="btn-remove btnremove"
                                        :data-referindex="index"
                                        :data-userid="value.user_id"
                                        :data-userrule="value.user_rule"
                                        data-action="remove"
                                        @click="buttonActions($event)"
                                    >
                                        <span class="content-icon"
                                            >Remover</span
                                        >
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table-element>
            </div>

            <!-- Mobile Card List Render -->
            <div class="user-mobile-section mobile-only">
                <template
                    v-for="(value, index) in usersData"
                    :key="value.user_id"
                >
                    <card-element
                        classname="user"
                        :data-referindex="index"
                        :data-userid="value.user_id"
                    >
                        <template #cardheadercontent>
                            <div class="header-text-content">
                                <div class="user-name strong-600">
                                    {{ value.user_name }}
                                </div>

                                <div class="caption-lg color-text-body">
                                    {{ value.rule_name }}
                                </div>
                                <div class="caption-lg color-text-body">
                                    <span class="color-text-action caption-lg"
                                        >ID:
                                    </span>
                                    {{ value.user_id }}
                                </div>
                            </div>
                            <div class="header-buttons-content">
                                <div
                                    role="button"
                                    class="btn-edit"
                                    :data-referindex="index"
                                    :data-userid="value.user_id"
                                    :data-userrule="value.user_rule"
                                    data-action="edit"
                                    data-mobileindicate="usersshow"
                                    @click="buttonActions($event)"
                                >
                                    <span
                                        data-mobileindicate="usersshow"
                                        class="content-icon"
                                        >Visualizar</span
                                    >
                                </div>
                                <div
                                    role="button"
                                    class="btn-remove btnremove"
                                    :data-referindex="index"
                                    :data-userid="value.user_id"
                                    :data-userrule="value.user_rule"
                                    data-action="remove"
                                    @click="buttonActions($event)"
                                >
                                    <span class="content-icon">Remover</span>
                                </div>
                            </div>
                        </template>

                        <template #cardbodycontent>
                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">Email:</p>
                                <p class="black overflow-elipse">
                                    {{ value.email }}
                                </p>
                            </div>

                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Telemóvel
                                </p>
                                <p
                                    :style="
                                        !value.contact
                                            ? {
                                                  textAlign: 'end',
                                                  width: '100%',
                                              }
                                            : null
                                    "
                                    class="black"
                                >
                                    {{
                                        value.user_rule ===
                                        parseInt(professionalrule)
                                            ? value.contact.contact || "-"
                                            : value.contact || "-"
                                    }}
                                </p>
                            </div>

                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Totais de pedidos:
                                </p>
                                <p class="black">{{ value.total_booking }}</p>
                            </div>
                        </template>
                    </card-element>
                </template>
            </div>

            <!-- Pagination -->
            <template v-if="wichUser === 'professional'">
                <pagination
                    :totalpages="parseInt(totalpages)"
                    :firstpageurl="firstpage"
                    :otherpagesurl="filePageUrl"
                    modulename="user"
                />
            </template>
        </template>

        <!-- Back To Top -->
        <back-to-top idhref="user_header" />

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>

<script>
import fetchData from "./../../fetchData.js";
import ListMessage from "./../elements/ListMessageElement.vue";
import Loading from "./../elements/LoadingElement.vue";
import Table from "./../elements/TableElement.vue";
import Pagination from "./../elements/PaginationElement.vue";
import BackToTop from "./../elements/BackToTopElement.vue";
import ModuleAction from "./../elements/ModuleActionElementNew.vue";
import Modal from "./../elements/ModalElement.vue";
import defaultWebsite from "./../../defaultWebsiteScript.js";
import responseMessage from "./../../responseMessage.js";
import CardElement from "./../elements/CardElement.vue";

("use strict");

export default {
    name: "UserAdmin",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        adminurl: {
            type: String,
            required: true,
        },
        modulesearch: {
            type: String,
            required: true,
        },
        moduleorder: {
            type: String,
            required: true,
        },
        modulefilter: {
            type: String,
            required: true,
        },
        modulecreate: {
            type: String,
            required: true,
        },
        moduleremove: {
            type: String,
            required: true,
        },
        totalpages: {
            type: String,
            required: true,
        },
        firstpage: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        moduleurlbase: {
            type: String,
            required: true,
        },
        professionalrule: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            allData: {},
            professionalAllData: {},
            adminAllData: {},
            moduleshow: "",
            modaltitle: "",
            modaldescription: "",
            modaloptions: {},
            activeclass: "d-flex",
            filePageUrl: "",
            usersData: [],
            wichUser: "",
            responseTimeOut: 10000,
            moduleDataAction: {},
        };
    },
    created() {
        //Set Data
        this.allData = JSON.parse(this.moduledata);
        this.professionalAllData = JSON.parse(this.allData.professionalusers);
        this.adminAllData = JSON.parse(this.allData.adminusers);

        //Set Form Show Url
        this.moduleshow = this.adminurl + `${this.moduleurlbase}/usershow=`;

        //Set Page Url
        this.filePageUrl = this.firstpage + "/page=";
        this.moduleDataAction = JSON.stringify(this.moduleDataAction);
    },
    mounted() {
        //Set user Data
        this.usersData = this.buttonsActionsHeader(null, "professional");

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        resumeMessage(text, limit, divisor) {
            //console.log(text);
            if (text !== undefined) {
                let resume =
                    text.length > limit
                        ? `${text.substr(
                              0,
                              Math.round(text.length / divisor)
                          )}...`
                        : text;

                return resume;
            }
        },
        getDynamicDataFromModuleAction(dynamicData) {
            //Set Dynamic Data when clean search input
            if (
                dynamicData !== undefined &&
                typeof dynamicData === "object" &&
                Object.values(dynamicData).length > 0
            ) {
                //Get Default Module Data
                this.usersData = dynamicData;

                return;
            }

            this.usersData = this.$data[`${this.wichUser}AllData`];
        },
        buttonActions(element) {
            //Get Data for Button Action
            let id = element.currentTarget.getAttribute("data-userid");
            //let referindex = element.currentTarget.getAttribute('data-referindex');
            let action = element.currentTarget.getAttribute("data-action");

            //Set Action bu button
            switch (action) {
                //Edit
                case "edit":
                    //window.location.replace(this.moduleshow + id);

                    defaultWebsite.primarySidebarConditional(
                        element,
                        "mobileconditional",
                        id
                    );

                    break;

                //Remove
                case "remove":
                    //Data Form
                    let dataForm = {
                        id: id,
                        action: action,
                        rule: parseInt(
                            element.currentTarget.getAttribute("data-userrule")
                        ),
                    };

                    //Remove routine
                    this.removeData(dataForm);

                    break;
            }
        },
        buttonsActionsHeader(element = null, indicate = null) {
            //Check actions
            let action =
                element !== null
                    ? element.target.getAttribute("data-action")
                    : indicate;

            //Selected Button
            [...document.querySelectorAll(".buttonlist")].forEach((value) => {
                value.classList.remove("selected");

                if (value.getAttribute("data-action") === action) {
                    value.classList.add("selected");
                }
            });

            //Set Wich User
            this.wichUser = action;

            //Set Module Data Action
            this.moduleDataAction = JSON.stringify(
                this.$data[`${action}AllData`]
            );

            //Set Manage Booking Data
            return this.$data[`${action}AllData`];
        },
        getUserData(userdata) {
            this.usersData = userdata;
        },
        showModal(element, classname) {
            //Set Modal Data
            this.modaltitle = element.name;
            this.modaldescription = element.description;
            this.modaloptions = element.options;

            //Show Modal
            $(`.${classname}`).modal("show");

            return;
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");

            return;
        },
        removeElement(elementrefer, attr, attrvalue) {
            //Remove Element
            [...document.querySelector(elementrefer).children].forEach(
                (value) => {
                    if (
                        parseInt(value.getAttribute(attr)) ===
                        parseInt(attrvalue)
                    ) {
                        value.remove();
                    }
                }
            );
        },
        removeData(data) {
            //Disabled Button
            document
                .querySelector(`.btn${data.action}`)
                .setAttribute("disabled", true);

            //Confirm Message
            let confirmMessage = `Favor confirmar a exclusão do user de id nº ${data.id} ?`;

            //Confirm Remove
            let confirmRemove = confirm(confirmMessage);

            if (!confirmRemove) {
                //Enabled Button
                document
                    .querySelector(`.btn${data.action}`)
                    .removeAttribute("disabled");

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                this.moduleremove,
                data,
                this.csrftolken,
                "DELETE"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Set Att Data
                    if (value.hasOwnProperty("attData") && value.classname === 'success') {
                        //Get Module Data
                        this.$data[`${value.attData.condition}AllData`] =
                            value.attData[value.attData.condition];

                        //Remove Element
                        this.removeElement("tbody", "data-userid", data.id);

                        return;

                    }

                    //Get Module Data
                    this.$data[`${value.attData.condition}AllData`] = value.attData[value.attData.condition];


                })
                .catch((error) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedAllData() {
            return this.allData;
        },
        computedUserData() {
            return this.usersData;
        },
    },
    watch: {
        computedAllData() {},
        computedUserData() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        tableElement: Table,
        pagination: Pagination,
        backToTop: BackToTop,
        moduleAction: ModuleAction,
        modal: Modal,
        cardElement: CardElement,
    },
};
</script>
